@for(m of markets(); track m.ref){
	@if(m.type=='market'){
		<div class="collapse collapse-plus bg-base-100 border border-base-300 mb-1">
		  <input type="radio" name="markets"/>
		  <div class="collapse-title font-semibold">
		  	<img class="market-icon" [src]="m | imgMarketPlace"/>
		  	{{m.name}}
		  </div>
		  <div class="collapse-content">
		  	@if(m.display){
		  		@let filtered=getPrices(m);
		  		@if(filtered.length){
			  		<div class="overflow-x-auto">
					  <table class="table">
					    <!-- head -->
					    <thead>
					      <tr>
					        <th>Lang.</th>
					        <th>Condition</th>
					        <th>Prix</th>
					      </tr>
					    </thead>
					    <tbody>
					      <!-- row 1 -->
					      @for(price of filtered; track price.ident){
						    <tr>
						        <td>
						        	<img src="img/skin/flag-{{price.lang}}.svg"/>
						        </td>
						        <td class="state-card">
						        	<lgb-rate [rate]="price.condition | valCondition"></lgb-rate>
						        	<span class="pl-1 text-xs uppercase tracking-wide">{{price.condition}}</span>
						        </td>
						        <td>
						        	{{price.amount | number:'1.2-2':'fr-FR'}}€
						        </td>
						    </tr>
					      }
					    </tbody>
					  </table>
					</div>
				}
				@else{
		  			<span class="opacity-60">Aucune offre.</span>
				}
			}
			@else{
		  		<span class="opacity-60">Arrive prochainement.</span>
			}
		  </div>
		</div>
	}
}